module.exports = __webpack_public_path__ + "assets/img/K13.77e33e26.png";